module.exports = "/lucky-balls/img/weager/Lower_Raise/Button_Higher_pressed.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Lower_Raise/Button_Higher_pressed.png
// module id = 1164
// module chunks = 0